import React, { Component } from 'react';
import './AuthLayout.scss';

const AuthLayout = ({ children }: any) => {
  return (
    <div className="authlayout-main">
      <div className="authlayout-banner-container">
        &nbsp;
      </div>
      <div className="authlayout-content">
        {/* <div className="authlayout-img-block">
          FEC
        </div> */}

        <div className="authlayout-form-block">
          <div className="authlayout-form-inner">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
